<template>
  <div class="input-model-box">
    <el-input
      placeholder="请输入名称或编码"
      v-model="warehouseName"
      @blur="warehouseNameChange"
      :disabled="column.disabled"
    >
      <template slot="append">
        <div class="el-icon-more more-btn" @click="showWarehouseList"></div>
      </template>
    </el-input>
    <el-dialog
      :title="column.label"
      :visible.sync="dialogVisible"
      @close="beforeClose"
      center
      :modal-append-to-body="false"
    >
      <purchase-list-template
        ref="listTable"
        @rowClick="warehouseCheck"
        :tableOptions="tableOptions"
      ></purchase-list-template>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/config/api";
import purchaseListTemplate from "@/components/template/purchaseListTemplate.vue";

export default {
  components: { purchaseListTemplate },
  props: ["column", "defaultValue"],
  data() {
    return {
      warehouseName: "",
      checkList: [],
      dialogVisible: false,
      warehouseList: null,
      tableOptions: {
        url: api.warehouse.warehouse + "/page",
        height: "100%",
        isRowClick: true,
        columns: [
          { label: "编码", prop: "number", align: "center" },
          { label: "名称", prop: "name", align: "center" }
        ]
      },
      btnClick: false
    };
  },
  watch: {
    defaultValue() {
      if (this.defaultValue > 0){
        this.$axios
          .fetchGet(api.warehouse.warehouse + "?id=" + this.defaultValue)
          .then(res => {
            console.log(res);
            this.warehouseName = res.data.name;
          });
      }
    }
  },
  methods: {
    initData() {
      this.warehouseName = "";
      this.checkList = {};
    },
    showWarehouseList() {
      if (this.column.disabled) return;
      this.btnClick = true;
      this.dialogVisible = true;
      this.getWarehouseList();
    },
    warehouseNameChange() {
      if (this.btnClick) return;
      if (this.warehouseName === "" || this.warehouseName === null) return;
      this.dialogVisible = true;
      this.getWarehouseList();
    },
    getWarehouseList() {
      if (this.btnClick) this.warehouseName = "";

      this.warehouseList = [];
      this.$nextTick(() => {
        this.$refs["listTable"].initData({
          storeId: this.column.params && this.column.params.storeId,
          name: this.warehouseName
        });
        this.setWarehouseName();
      });
    },
    setWarehouseName() {
      if (this.warehouseList.length == 1) {
        this.checkList = this.warehouseList[0];
        this.warehouseName = this.warehouseList[0].name;
        this.$emit("valueChange", this.checkList.id, this.column);
      } else {
        this.dialogVisible = true;
      }
    },
    warehouseCheck(row) {
      this.checkList = row;
      this.warehouseName = row.name;
      this.dialogVisible = false;
      console.log(row.id, this.column);
      this.$emit("valueChange", row.id, this.column);
    },
    beforeClose() {
      this.warehouseName = this.checkList.name;
      this.btnClick = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/business/warehouseInputDialog.vue